export default __webpack_public_path__ + "static/media/logo_stang.a50f0851.png";